import _ from 'lodash';
import GatewayService from '../GatewayService.js';
var slidesService = new GatewayService('slides-services');
import { missingParam } from '../errors.js';
import log from '../log.js';
import axios from '../axios.js';
import config from '../amp-config.js';

var copyGoogleSlidesPresentation = function copyGoogleSlidesPresentation(presentationId, unitKey, chapterKey, unitRevision, lessonKey, edition, extraParams) {
  if (_.isEmpty(presentationId)) {
    log.error('Presentation not copied because presentationId was not specified');
    return Promise.reject(missingParam('presentationId'));
  }

  if (_.isEmpty(unitKey)) {
    log.error('Presentation not copied because unitKey was not specified');
    return Promise.reject(missingParam('unitKey'));
  }

  if (_.isEmpty(chapterKey)) {
    log.error('Presentation not copied because chapterKey was not specified');
    return Promise.reject(missingParam('chapterKey'));
  }

  if (_.isEmpty(unitRevision)) {
    log.error('Presentation not copied because unitRevision was not specified');
    return Promise.reject(missingParam('unitRevision'));
  }

  if (_.isEmpty(lessonKey)) {
    log.error('Presentation not copied because lessonKey was not specified');
    return Promise.reject(missingParam('lessonKey'));
  }

  if (_.isEmpty(edition)) {
    log.error('Presentation not copied because edition was not specified');
    return Promise.reject(missingParam('edition'));
  }

  var body = Object.assign({}, {
    unitKey: unitKey,
    chapterKey: chapterKey,
    unitRevision: unitRevision,
    lessonKey: lessonKey,
    edition: edition
  }, extraParams);
  return slidesService.post("v2/gdrive/files/".concat(presentationId, "/copy"), body);
};

var getGoogleAuthSlidesStatus = function getGoogleAuthSlidesStatus(redirectUrl) {
  if (_.isEmpty(redirectUrl)) {
    log.error('Google auth status not fetched because redirectUrl was not specified');
    return Promise.reject(missingParam('redirectUrl'));
  }

  return slidesService.get("v2/google/auth?redirectUrl=".concat(redirectUrl));
};

var resetGoogleAuthSlidesStatus = function resetGoogleAuthSlidesStatus(ampId) {
  if (_.isEmpty(ampId)) {
    log.error('Google auth status not reset because ampId was not specified');
    return Promise.reject(missingParam('ampId'));
  }

  return config.get('gateway').then(function (gateway) {
    return axios["delete"]("".concat(gateway, "/user-storage-service/storagev3/").concat(ampId, "/google-auth"));
  });
};

export default {
  copyGoogleSlidesPresentation: copyGoogleSlidesPresentation,
  getGoogleAuthSlidesStatus: getGoogleAuthSlidesStatus,
  resetGoogleAuthSlidesStatus: resetGoogleAuthSlidesStatus
};